import { t } from '@ankr.com/common';

import { root } from '../../const';
import { usePremiumLabelStyles } from './PremiumLabelStyles';
import { FontSize } from './premiumLabelUtils';

export interface PremiumLabelProps {
  size?: FontSize;
  label?: string;
  preLabel?: string;
  className?: string;
  hasGradientBackground?: boolean;
  hasFlatBackground?: boolean;
}

export const PremiumLabel = ({
  className,
  hasFlatBackground,
  hasGradientBackground,
  label,
  preLabel,
  size = 's',
}: PremiumLabelProps) => {
  const { classes, cx } = usePremiumLabelStyles({
    size,
    hasGradientBackground,
    hasFlatBackground,
  });

  return (
    <div className={cx(classes.premiumLabel, className)}>
      {preLabel && (
        <>
          <span className={classes.preLabel}>{preLabel}</span>
          <span className={classes.divider}>/</span>
        </>
      )}

      <span
        className={cx(classes.gradient, {
          [classes.noPaddingLeft]: Boolean(preLabel),
        })}
      >
        {label || t(`${root}.endpoints.premium-label`)}
      </span>
    </div>
  );
};
